import styled from "@emotion/styled";
import { monochromeColor } from "constants/colorPalette";
import Modal from "ui/overlays/Modal";

export const CommodityFilterModalContainer = styled(Modal)`
  .mantine-Modal-content {
    min-height: 41px;
    padding: 1rem;
    @media only screen and (max-width: ${props => props.theme.other.breakpoints.lg}) {
      padding: 1rem;
    }
  }
`;

export const CommodityFilterHeader = styled.div`
  font-family: ${props => props.theme.other.font.fontFamily};
  font-style: ${props => props.theme.other.font.fontStyle};
  font-weight: 700;
  font-size: 1.8rem;
  line-height: 3.8125rem;
  text-align: left;
  color: ${props => props.theme.other.primaryColor};
  margin-bottom: 1.5rem;
`;

export const FiltersContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 3rem;

  @media screen and (max-width: ${props => props.theme.other.breakpoints.lg}) {
    gap: 2rem;
  }
`;

export const StyledRow = styled.div`
  width: 100%;
  gap: 4rem;
  display: flex;
  justify-content: space-between;

  @media screen and (max-width: ${props => props.theme.other.breakpoints.lg}) {
    flex-direction: column;
    gap: 2rem;
  }
`;

export const AutocompleteWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const StyledFilterTitle = styled.div<{ inline?: boolean }>`
  padding-bottom: ${props => (props.inline ? "" : "0.5rem")};
  font-size: ${props => props.theme.other.font.modalGroupHeader.fontSize};
  line-height: ${props => props.theme.other.font.modalGroupHeader.lineHeight};
  font-weight: ${props => props.theme.other.font.modalGroupHeader.fontWeight};
  color: ${monochromeColor[2]};
`;

export const StyledInputWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 1rem;
`;

export const Footer = styled.div`
  width: 100%;
  padding-top: 36px;
  margin-top: 2.5rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const ResetButton = styled.div`
  font-family: ${props => props.theme.other.font.fontFamily};
  font-style: ${props => props.theme.other.font.fontStyle};
  font-weight: 400;
  font-size: ${props => props.theme.other.font.paragraph.fontSize};
  line-height: ${props => props.theme.other.font.paragraph.lineHeight};
  color: #5c5c5c;
  margin-right: 28px;
  cursor: pointer;
`;
